import {useState, useEffect} from "react";
import {apiKeyDataTehnology, urlApiDataTehnology} from "../helper/api";
import {IEsgResponseSingleFromCMS, ISettingFromServer} from "../types";

// Глобальный кеш для предотвращения множественных запросов
let globalSettingData: IEsgResponseSingleFromCMS<ISettingFromServer> | null =
  null;
let globalError: Error | null = null;
let globalLoading = false;
let globalPromise: Promise<any> | null = null;

const useFetchDataLogotypeGpb = () => {
  const apiUrl = `${urlApiDataTehnology}/api/setting`;
  const apiKey = apiKeyDataTehnology;

  const [settingData, setSettingData] =
    useState<IEsgResponseSingleFromCMS<ISettingFromServer> | null>(
      globalSettingData
    );
  const [error, setError] = useState<Error | null>(globalError);

  useEffect(() => {
    // Если данные уже загружены, используем их
    if (globalSettingData) {
      setSettingData(globalSettingData);
      setError(globalError);
      return;
    }

    // Если запрос уже выполняется, ждем его результата
    if (globalLoading && globalPromise) {
      globalPromise.then(() => {
        setSettingData(globalSettingData);
        setError(globalError);
      });
      return;
    }

    // Выполняем запрос только если его еще нет
    if (!globalLoading) {
      globalLoading = true;

      const headers = new Headers({
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json",
      });

      const url = new URL(apiUrl);
      url.searchParams.set("populate", "*");

      globalPromise = fetch(url.href, {method: "GET", headers})
        .then((response) => response.json())
        .then((data) => {
          globalSettingData = data;
          globalError = null;
          setSettingData(data);
          setError(null);
        })
        .catch((error) => {
          globalError = error;
          globalSettingData = null;
          setError(error);
          setSettingData(null);
        })
        .finally(() => {
          globalLoading = false;
        });
    }
  }, [apiUrl, apiKey]);

  return {settingData, error};
};

export default useFetchDataLogotypeGpb;
